// extracted by mini-css-extract-plugin
export default {"photo-carousel-container":"photo-carousel-container--mp-XvBw1","photoCarouselContainer":"photo-carousel-container--mp-XvBw1"};